import { Component, OnInit, Input, ViewChild, TemplateRef } from '@angular/core';
import {CollegeService } from '@app/_services/masters/college.service';
import { college } from '@app/_models/college';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { NgbModalConfig, NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { LogService } from '../../../_shared/log.service'

@Component({
  selector: 'app-college-master-edit',
  templateUrl: './college-master-edit.component.html',
  styleUrls: ['./college-master-edit.component.css']
})
export class CollegeMasterEditComponent implements OnInit {

  colegId: number;
  editCollegeForm: FormGroup;
  college: college[];
  submitted = false;
  collegeName: string;
  response: any;
  collegeId: number;
  getresponse: any;
  strMessage:string;
  
  get f() { return this.editCollegeForm.controls; }

  showModalBox: boolean = false;
  @ViewChild('showModalBox', { read: TemplateRef }) showModalBoxTemplate: TemplateRef<any>;

  constructor(private eventService: LogService, private formBuilder: FormBuilder, private collegeService: CollegeService,
    private modalService: NgbModal, config: NgbModalConfig) { }

  @Input() childMessage: college[];

  receiveDocumentId(p) {
    this.colegId = p;
  }

  ngOnInit(): void {
    
    console.log("childMessage" + this.childMessage);
    this.response = this.childMessage;
    this.collegeName = this.response.collegeName;
    this.collegeId = this.response.id;
    this.editCollegeForm = this.formBuilder.group({
      collegeName: ['', Validators.required]
    });
  }

  updateCollege() {
    this.submitted = true;

    if (this.editCollegeForm.invalid) {
      return;
    }
    var v = new college();
    v.collegeName = this.collegeName;
    v.id = this.collegeId;
    this.collegeService.updateCollege(v)
      .subscribe((response) => {
        if (response) {
          this.getresponse = response;
          if (this.getresponse.respMessage == "Success") {
            this.strMessage="College Updated Successfully.";
            this.modalService.open(this.showModalBoxTemplate);
            var v = response;
          }
        
        else if (this.getresponse.respMessage == "Failure") {
          this.strMessage=this.getresponse.respData;
          this.modalService.open(this.showModalBoxTemplate);
          var v = response;
        }
        }
      },
        (err: any) => {
          var message = err;
        });
  }

  refresh(): void {
    this.modalService.dismissAll(this.showModalBoxTemplate);
    this.eventService.emit<string>('13');
  } 
  
  goBack()
  {
    this.eventService.emit<string>('13');
  }

}
